import {Component, Directive, ElementRef, HostBinding, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'validation-messages',
  template: `
    <div *ngIf="showError">
      <div class="error-message" *ngFor="let error of errorDescriptions">*{{error}}</div>
    </div>
  `,
  styles: [".error-message{color: red;font-size: 0.7rem}"]
})
export class ValidationMessagesComponent implements OnInit {
  @Input() control: FormControl;
  @Input() customErrors = [];
  errorDescriptions: Array<string> = [];

  constructor(private el: ElementRef) {
  }

  get showError() {
    if (this.control.invalid && this.control.touched && this.control.errors) {
      this.errorDescriptions = [];
      console.log(this.control.errors);
      Object.keys(this.control.errors).forEach((keyError) => {
        this.validationMessage(keyError, this.control.errors[keyError]);
      });
    }
    return this.control.invalid && this.control.touched && this.control.errors;
  }

  ngOnInit() {

  }


  private validationMessage(errorKey: string, error?: any) {
    console.log("validationMessage:errorKey", errorKey);
    console.log("validationMessage:error", error);
    switch (errorKey) {
      case 'required':
        this.addErrorDescription(errorKey, 'Requerido');
        break;

      case 'minlength':
        this.addErrorDescription(errorKey, `Deber tener al menos ${error.requiredLength} caracteres`);
        break;

      case 'maxlength':
        this.addErrorDescription(errorKey, `No pueder contener más de ${error.requiredLength} caracteres`);
        break;

      case 'email':
        this.addErrorDescription(errorKey, `Ingresa una dirección de correo electrónico válida`);
        break;

      case 'onlyNumbers':
        this.addErrorDescription(errorKey, `Introduce números únicamente`);
        break;

      case 'legalAge':
        this.addErrorDescription(errorKey, `Debes de ser mayor de edad`);
        break;

      case 'pattern':
        this.addErrorDescription(errorKey, `El formato no es válido`);
        break;

      default:
        this.addErrorDescription(errorKey, 'El valor es inválido');
    }
  }

  private addErrorDescription(errorKey, message) {
    if (this.customErrors[errorKey]) {
      this.errorDescriptions.push(this.customErrors[errorKey]);
    } else {
      this.errorDescriptions.push(message);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/validators/validation-messages.component.ts